export default "__VITE_ASSET__bf56ad7f__"